import { render } from "./TextAnnotatePanel.vue?vue&type=template&id=2a50c912"
import script from "./TextAnnotatePanel.vue?vue&type=script&lang=js"
export * from "./TextAnnotatePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__